/*global googletag, window*/

export const GetTileAdListToDisplay = function(view) {
  var adUnitsListToDisplay = [];
  $('.ad-data-' + view + '-view').each(function(i, item)
      {
        if (!$(item).hasClass('lazy_load')) {
          var adUnit = item.dataset['adUnit'];
          if (adUnit) {
            adUnitsListToDisplay.push(adUnit);
          }
        }
      }
  );
  return adUnitsListToDisplay.join(',');
};

const TileAdLazyLoading = function(getDynamicAdsToBeLoaded, loadProgrammaticAds, view) {
  var listview = view.toLowerCase() === 'list';
  var viewList = listview ? '.ad-data-list-view.lazy_load' : '.ad-data-map-view.lazy_load';
  var gptadslotsForView = listview ? window.gptAds.gptadslotsTXTINListView : window.gptAds.gptadslotsTXTINMapView;
  $(viewList).each(function(i, item)
      {
        var adUnit = item.dataset['adUnit'];
        if (adUnit && !$(item).hasClass('registered')) {
          $(item).addClass('registered');
          var adUnitsListToDisplay = [];
          adUnitsListToDisplay.push(adUnit);
          var adsToLoad = getDynamicAdsToBeLoaded(adUnitsListToDisplay.join(','), gptadslotsForView);
          adsToLoad.forEach(function (slot) {
            let threshold = MOVE.Helper.isPhone() ? 7000 : 800;
            MOVE.DOMHelper.unveilLoadContent($('#' + slot.getSlotElementId()), $('.srp-card-wrapper'), threshold, function () {
              googletag.cmd.push(function() {
                var adsToLoad = [];
                adsToLoad.push(slot);
                loadProgrammaticAds(adsToLoad);
              });
            });
          });
        }
      }
  );
};

export const TileAdLazyLoad = function(getDynamicAdsToBeLoaded, loadProgrammaticAds, view) {
  if (!view || view === 'map-only') {
    return;
  }
  setTimeout(function() {
    TileAdLazyLoading(getDynamicAdsToBeLoaded, loadProgrammaticAds, view);
  }, 500);
};



// WEBPACK FOOTER //
// ./shared_critical/media/tile.js